import NotificationsManager from './NotificationsManager';

export default NotificationsManager;
